// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".socket-menu-item{display:flex;justify-content:space-between}\n", "",{"version":3,"sources":["webpack://./src/routes/interactive_mode/interactive_mode.scss"],"names":[],"mappings":"AACA,kBACE,YAAa,CACb,6BAA8B","sourcesContent":["\n.socket-menu-item{\n  display: flex;\n  justify-content: space-between;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
